<template>
  <div class="help-container" id="success-modal">
    <div id="title">
      <div class="container">
        <img src="~@/assets/logos/Mariposa.png" alt=""> 
        <h3 class="title is-3 helvetica">
          {{ title }}
        </h3>
      </div>
    </div>
    <div id="message" class="postScriptum" :style="{ background: bgColor }">
      <div class="container">
        <h4 class="title is-4" v-html="content"></h4>
      </div>
    </div>
    <div id="close" class="helvetica">
      <div class="container">
        <h4 class="title is-4">
          {{ helpText }}
        </h4>
        <b-button @click="closeModal" expanded size="is-medium is-pink">
          {{ confirmText }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['content', 'bgColor', 'number', 'helpText', 'confirmText', 'title'],
  methods: {
    closeModal() {
      this.$emit('close', {})
    }
  }
}
</script>

<style lang="scss">
.v-dialog-modal .v-dialog-body {
  padding: 0 !important;
}

div.v-dialog div.v-dialog-content {
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px) brightness(1.5);
}

#success-modal.help-container {
  height: 100%;
  display: grid;
  grid-template-rows: min-content min-content min-content;

  > div {
    justify-self: stretch;
    display: flex;
  }
  .container {
    margin: auto;
    text-align: center;
    padding: 20px;
  }

  #message {
    * {
      color: white;
    }
  }

  #title {
    .title {
      color: #ce3f86;
    }
    img {
      height: 130px;
    }
    h1 {
      font-size: 5em !important;
    }

    h4 {
      margin-bottom: 0;
    }
  }

  #close {
    .title {
      color: #ce3f86;
    }

    .help-container {
      height: 100%;
      display: grid;
      grid-template-rows: 33% 33% 33%;

      > div {
        justify-self: stretch;
        display: flex;
      }
      .container {
        margin: auto;
        text-align: center;
        padding: 20px;
      }

      #message {
        background: red; /*COLOR */

        * {
          color: white;
        }
      }

      #title {
        .title {
          color: var(--rosa-dark-eco);
        }
        img {
          height: 130px;
        }
        h1 {
          font-size: 5em !important;
        }

        h4 {
          margin-bottom: 0;
        }
      }

      #close {
        .title {
          color: var(--rosa-dark-eco);
        }
        button {
          background: var(--rosa-dark-eco);
          color: white;
        }
      }
    }
  }
}
</style>
